import { algodHost, algodPort, algodToken } from "@/config";
import { queryClient } from "@/lib/query-client";
import { useQuery } from "@tanstack/react-query";

export const useBlockTime = (rnd: number | bigint) => {
  return useQuery({
    queryKey: ["block-ts", rnd ? String(rnd) : "-"],
    gcTime: 10 * 365 * 24 * 60 * 60 * 1_000,
    staleTime: 10 * 365 * 24 * 60 * 60 * 1_000,
    queryFn: async (): Promise<number | null> => {
      if (!rnd) return null;
      const url = `${algodHost}:${algodPort}/v2/blocks/${rnd}?header-only=true`;
      const response = (await fetch(
        url,
        { headers: { "X-Algo-API-Token": algodToken } }
      ));
      const { block: { ts } } = await response.json()
      return ts as number;
    },
  });
};

export const clearListingsCache = () => {
  queryClient.invalidateQueries({ queryKey: ["listings"] });
};
